var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-container"},[_c('Survey',{attrs:{"questions":_vm.questions,"previous-component-name":_vm.previousComponentName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }